import { useCallback, useEffect, useRef, useState } from 'react';
import { getPriceListBranchOverview } from '../api';
import { subscribeProductEvents } from '../utils/productEventsHub';
import useCatalogUpdateQueue from './useCatalogUpdateQueue';

export default function usePriceListBranchOverview({ branchId, companyId, enabled, refreshKey }) {
  const [state, setState] = useState({});
  const request = useRef(0);
  const scope = `${companyId}:${branchId}`;
  const refresh = useCallback(async () => {
    if (!enabled || !branchId) return;
    const id = ++request.current;
    setState((current) => ({ ...current, loading: true }));
    try {
      const data = await getPriceListBranchOverview(branchId);
      if (request.current === id) setState({ scope, data, loading: false });
      return data;
    } catch (error) {
      if (request.current === id) setState({ scope, error: error?.response?.data?.message || 'No se pudieron cargar las ofertas de sucursales. Reintenta.', loading: false });
    }
  }, [branchId, scope, enabled]);
  const queue = useCatalogUpdateQueue(`${companyId}:${branchId}`, refresh);
  useEffect(() => {
    void refresh();
    return () => { request.current += 1; };
  }, [refresh, refreshKey]);
  useEffect(() => {
    if (!enabled) return undefined;
    const invalidate = (event = {}) => {
      if (event.companyId && companyId && Number(event.companyId) !== Number(companyId)) return;

      return queue(event);
    };
    const unsubscribe = subscribeProductEvents(invalidate);
    const onFocus = () => { void invalidate(); };
    window.addEventListener('focus', onFocus);
    return () => { unsubscribe(); window.removeEventListener('focus', onFocus); };
  }, [enabled, companyId, queue]);
  return { ...(state.scope === scope ? state : { loading: enabled }), refresh };
}
